import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as SearchIcon } from './search-icon.svg';
import { CheckBox } from '../CheckBox/CheckBox';
import Input from '../Input/Input';
import { classNames } from '../utils';
import './InputDropDown.scss';

export const InputDropDownCommissionSearch = ({
  autoComplete = 'off',
  options,
  name,
  error,
  value,
  onChange,
  label = '',
  placeholder,
  subText,
  className,
  topLabel,
  initialStatus,
  isRequired,
  isDisabled,
  isClearSearchValue = false,
  setIsClearSearchValue
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterText, setFilterText] = useState('');
  const dropdownRef = useRef(null);

  const inputClasses = classNames({
    'input-wrapper-dropdown': true,
    active: isMenuOpen || value?.length,
    disabled: isDisabled,
    error: !!error,
    hit: !error && !!initialStatus,
    [className]: true
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownRef, value, searchText]);

  useEffect(() => {
    setSearchText(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, options]);

  useEffect(() => {
    if (isClearSearchValue) {
      setSearchText('');
      setIsClearSearchValue(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClearSearchValue]);

  useEffect(() => {
    setFilterText(searchText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  useEffect(() => {
    if (isMenuOpen) {
      setFilterText('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMenuOpen]);

  const inputChange = (data) => {
    onChange(name, options?.find((option) => option?.key === data)?.value);
    setIsMenuOpen(false);
  };

  const onSearchFocus = (e) => {
    if (options && !isDisabled && !(isMenuOpen && e.target?.name === name)) {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  const onSearchChange = (e) => {
    setSearchText(e.target.value);
    onChange(name, e.target.value);
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div ref={dropdownRef} onClick={onSearchFocus} className={inputClasses}>
      {topLabel && <p className={'top-label'}>{topLabel}</p>}
      <Input
        label={label + (isRequired ? '*' : '')}
        autoComplete={autoComplete}
        name={name}
        value={searchText}
        onChange={(e) => onSearchChange(e)}
        Icon={SearchIcon}
        className={'input-dropdown-input'}
        placeholder={placeholder}
        isDisabled={isDisabled}
      />
      {isMenuOpen && (
        <div className={'input-dropdown-menu'}>
          {options
            .filter((dataPoint) => dataPoint.value?.toLowerCase()?.includes(filterText?.toLowerCase()))
            .map((dataPoint) => (
              <CheckBox
                key={dataPoint.key}
                onChange={() => inputChange(dataPoint.key)}
                isActive={dataPoint.key === value}
                showCheckBox={false}
                value={dataPoint.value}
              />
            ))}
        </div>
      )}
      {(error || subText) && <p className={`input-sub-text ${error ? 'input-error' : ''}`}>{error || subText}</p>}
    </div>
  );
};

InputDropDownCommissionSearch.propTypes = {
  autoComplete: PropTypes.string,
  options: PropTypes.array,
  specificOptions: PropTypes.array,
  name: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  subText: PropTypes.string,
  className: PropTypes.string,
  topLabel: PropTypes.string,
  initialStatus: PropTypes.number,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isClearSearchValue: PropTypes.bool,
  setIsClearSearchValue: PropTypes.func
};
